import * as React from 'react';

import ButtonBar from 'components/molecules/ButtonBar';
import EditableArea from 'components/molecules/EditableArea';

import { warn } from 'helper/debug';
import i18n from 'helper/i18n';

import { ButtonProps } from 'components/molecules/Button';
import { EditableAreaRenderButtonBarOptionsType } from 'components/molecules/EditableArea';
export type ProfileSloganPropsType = {
	slogan: string;
	isUpdatingSlogan: boolean;
	doSaveSlogan: (slogan: string) => void;
};

export type ProfileSloganStateType = {
	slogan: string;
	optimisticSaveSlogan: string;
	isEditing: boolean;
};

export default class ProfileSlogan extends React.Component<ProfileSloganPropsType, ProfileSloganStateType> {
	public static displayName = 'ProfileSlogan';

	public state = {
		slogan: this.props.slogan,
		optimisticSaveSlogan: this.props.slogan,
		isEditing: false,
	};

	public handleButtonClicks = (buttonType: string) => {
		switch (buttonType) {
			case 'completed':
				this.setState({
					isEditing: false,
					optimisticSaveSlogan: this.state.slogan,
				});

				if (document && document.activeElement !== null) {
					(document.activeElement as HTMLElement).blur();
				}

				this.props.doSaveSlogan(this.state.slogan);

				break;
			case 'close':
				this.setState({
					isEditing: false,
					slogan: this.props.slogan,
				});
				break;
			default:
				warn(`Button Action "${buttonType}" not available`);
		}
	};

	public handleSloganChange = (newSlogan: string) => {
		this.setState({ slogan: newSlogan });
	};

	public handleEditStatusChange = () => {
		this.setState({ isEditing: !this.state.isEditing });
	};

	public getIntroText = () => {
		return i18n('react.impulsCoach.views.Profile.slogan.title');
	};

	public renderButtonBar = (options: EditableAreaRenderButtonBarOptionsType) => {
		const cardButtons: ButtonProps[] = [
			{
				type: this.state.slogan ? '' : 'disabled',
				knob: {
					modifier: 'dashed',
					size: 'l',
					icon: 'completed',
				},
				labelBottom: i18n('react.impulsCoach.components.cardDetail.slogan.buttons.label.save'),
			},
			{
				knob: {
					modifier: 'dashed',
					size: 'l',
					icon: 'close',
				},
				labelBottom: i18n('react.impulsCoach.components.cardDetail.slogan.buttons.label.cancel'),
			},
		];

		return (
			<ButtonBar
				loading={this.props.isUpdatingSlogan}
				handleButtonClicks={(buttonType: string) => {
					if (buttonType && buttonType.toUpperCase() === 'CLOSE') {
						options.onClickClose();
					}
					this.handleButtonClicks(buttonType);
				}}
				buttons={cardButtons}
			/>
		);
	};

	public render() {
		return (
			<EditableArea
				text={this.state.optimisticSaveSlogan}
				title={this.getIntroText()}
				placeholder={i18n('react.impulsCoach.views.Profile.slogan.placeholder')}
				isEditing={this.state.isEditing}
				isSlogan
				onChange={this.handleSloganChange}
				onChangeEditStatus={this.handleEditStatusChange}
				renderButtonBar={this.renderButtonBar}
			/>
		);
	}
}
